import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "How fast are the alerts delivered?",
    a: "Most alerts reach your phone in under 8 seconds. We use direct carrier routes for SMS and push notifications to minimize latency—no email delays, no app refreshes needed.",
  },
  {
    q: "Do I need trading experience to use RadarTicker?",
    a: "Not at all. Our alerts are designed to be actionable for beginners and seasoned traders alike. Each alert includes the ticker, the trigger condition, and the current price so you can make informed decisions quickly.",
  },
  {
    q: "Can I customize which alerts I receive?",
    a: "Absolutely. You set your own thresholds—price targets, volume spikes, percentage moves—and choose delivery via SMS, push, or both. You'll never get an alert you didn't ask for.",
  },
  {
    q: "How does pricing work?",
    a: "It's simple — $3 per month gets you 5 ticker alerts. Need more? Just add another pack. 10 tickers = $6/mo, 20 tickers = $12/mo. No tiers, no hidden fees. Scale up or down anytime.",
  },
  {
    q: "What markets and exchanges do you cover?",
    a: "We currently cover all major US exchanges including NYSE, NASDAQ, and AMEX. Pre-market (4 AM ET) and after-hours (8 PM ET) coverage is included with every pack.",
  },
  {
    q: "Can I cancel my subscription at any time?",
    a: "Yes—no contracts, no cancellation fees. You can upgrade, downgrade, or cancel directly from your account settings at any time. Your alerts stay active until the end of your billing period.",
  },
];

const FAQ = () => {
  return (
    <section className="py-20 md:py-28 px-6 bg-muted/40">
      <div className="container mx-auto max-w-3xl">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-accent uppercase tracking-wide mb-3">
            Got questions?
          </p>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-muted-foreground">
            Everything you need to know before you start.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-3">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="bg-card border border-border rounded-xl px-6 data-[state=open]:shadow-md transition-shadow"
            >
              <AccordionTrigger className="text-left text-[15px] font-semibold py-5 hover:no-underline">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-[15px] leading-relaxed pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
